import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { Scrollbar, Mousewheel, EffectCreative } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Arrow from "../../images/svg/arrow-small.inline.svg";
import { ReviewsCarouselProps } from "../interface/interface";
import * as styles from "./styles.module.css";

const ReviewsCarousel:React.FC<ReviewsCarouselProps> = ({slides}) => {
  return (
    <div className={styles.reviews}>
      <Swiper
        className={styles.slider}
        modules={[Scrollbar, Mousewheel, EffectCreative]}
        spaceBetween={20}
        slidesPerView={"auto"}
        centeredSlides={true}
        // mousewheel={true}
        scrollbar={{ hide: true }}
        breakpoints={{
          0: {
            spaceBetween: 20,
            centeredSlides: false,
            slidesPerView: 1.1,
          },
          600: {
            slidesPerView: 2,
          },
          768: {
            centeredSlides: false,
          },
          1238: {
            spaceBetween: 30,
            centeredSlides: false,
          }
        }}
      >
        {slides === "home" && <SwiperSlide className={styles.slide}>
          <div className={styles.review}>
                <div className={styles.person}>
                  <StaticImage
                    className={styles.image}
                    alt="brandon review image"
                    src="../../images/reviews/brandon-review.png"
                  />
                  <div>
                    <div className={styles.name}>Brandon Miller</div>
                    <div className={styles.account}>@thatguybmills</div>
                  </div>
                </div>
                <div className={styles.text}>
                  “For the past two months, I've been working out using my Gainful&nbsp;
                  system. Their <strong>Personalized Protein</strong> is dope, and I&nbsp;
                  appreciate how they make a custom blend based on your needs.”
                </div>
            <a className={styles.link} href="/product/protein">
              <StaticImage
                className={styles.icon}
                alt="protein image"
                src="../../images/reviews/protein-review.png"
              />
              <div>Find your
                <br/>
                Protein
                <Arrow className={styles.arrow} /></div>
              </a>
          </div>
        </SwiperSlide>}
        {slides === "trainer" && <SwiperSlide className={styles.slide}>
          <div className={styles.review}>
                <div className={styles.person}>
                  <StaticImage
                    className={styles.image}
                    alt="sophie review image"
                    src="../../images/reviews/sophie-review.png"
                  />
                  <div>
                    <div className={styles.name}>Sophie S.</div>
                    <div className={styles.account}>@fittwithsoph</div>
                  </div>
                </div>
                <div className={styles.text}>
                “I love this <strong>Personalized Protein Powder</strong> because it is customized to my goals & body type. I got my protein customized to lactose free, lean protein, soy free, and low carbs!”
                </div>
            <a className={styles.link} href="/product/protein">
              <StaticImage
                className={styles.icon}
                alt="protein image"
                src="../../images/reviews/protein-review.png"
              />
              <div>Find your
                <br/>
                Protein
                <Arrow className={styles.arrow} /></div>
              </a>
          </div>
        </SwiperSlide>}
        <SwiperSlide className={styles.slide}>
          <div className={styles.review}>
          <div className={styles.person}>
              <StaticImage
                className={styles.image}
                alt="kaylynn review image"
                src="../../images/reviews/kaylynn-review.png"
              />
              <div>
                <div className={styles.name}>Kaylynn Reyes</div>
                <div className={styles.account}>@_kickinitwithkay_</div>
              </div>
            </div>
            <div className={styles.text}>
              “This has easily been one of my favorite&nbsp;
              <strong>Pre-Workouts</strong>. I love the flavor, just the right&nbsp;
              amount of energy, added creatine, and vegan formula. It leaves me&nbsp;
              feeling great for any of my workouts and none of the jitters.”
            </div>
            <a className={styles.link} href="/product/preworkout">
              <StaticImage
                className={styles.icon}
                alt="pre-workout image"
                src="../../images/reviews/preworkout-review.png"
              />
              <div>Find your
                <br/>
                Pre-&nbsp;workout <Arrow className={styles.arrow} /></div>
            </a>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default ReviewsCarousel;
